var _defs, _path, _path2, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyBird(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 72 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#74a4ff;}.cls-3{fill:#86afff;}.cls-4{clip-path:url(#clip-path);}.cls-5{opacity:0.7;}.cls-17,.cls-6,.cls-8{fill:#fff;}.cls-6,.cls-8{opacity:0.4;isolation:isolate;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{fill-opacity:0.7;}.cls-9{clip-path:url(#clip-path-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{fill:#ffa33c;}.cls-12{fill:#ffc925;}.cls-13{fill:#ff9c2d;}.cls-14{fill:#ef8700;}.cls-15{fill:url(#linear-gradient);}.cls-16{fill:#6039ff;}.cls-18{fill:#282828;}.cls-19{clip-path:url(#clip-path-5);}.cls-20{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.53,
    y: 34.2,
    width: 25.35,
    height: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.88,
    y: 12.48,
    width: 29.64,
    height: 18.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.95,
    y: 45.41,
    width: 21.51,
    height: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10,
    y: 15.08,
    width: 52,
    height: 42.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.28,
    y1: 60.06,
    x2: 30.94,
    y2: 60.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 84.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe5ee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7b61e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#499de8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.8,
    y: 14.65,
    width: 10.58,
    height: 10.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 51.22,
    y1: 64.29,
    x2: 60.96,
    y2: 64.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 84.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67c84d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#60c261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4db395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2f9ae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9d56ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e24ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e44cd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e84cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ea4ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff6c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffb200"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.55,77.27a15.25,15.25,0,0,1-17.49,0L6.65,62.92A15.7,15.7,0,0,1,0,50.07V15.63A15.53,15.53,0,0,1,15.43,0H56.57A15.53,15.53,0,0,1,72,15.63V50a15.67,15.67,0,0,1-6.72,12.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.89,71.14a10.71,10.71,0,0,1-12.11,0L10.64,57.92A10.7,10.7,0,0,1,6,49.09V17.72A10.72,10.72,0,0,1,16.71,7H55.29A10.72,10.72,0,0,1,66,17.72V49.06a10.7,10.7,0,0,1-4.68,8.85Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.34,40.45a2.09,2.09,0,0,1,0-.25c0-2.76,2.84-5,6.34-5a6.76,6.76,0,0,1,5.49,2.51,4.17,4.17,0,0,1,2.11-.51c2.1,0,3.81,1.32,3.81,3a2.39,2.39,0,0,1-.26,1.08c2.32.37,4.06,2,4.06,3.92,0,2.21-2.27,4-5.07,4H44.23c-3.15,0-5.7-2-5.7-4.5C38.53,42.74,40.12,41.07,42.34,40.45Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M13.34,19.8c0-.1,0-.2,0-.3,0-3.23,3.32-5.85,7.41-5.85a7.92,7.92,0,0,1,6.42,2.93A5,5,0,0,1,29.63,16c2.46,0,4.45,1.54,4.45,3.51a2.93,2.93,0,0,1-.3,1.27c2.71.43,4.75,2.32,4.75,4.58,0,2.59-2.66,4.68-5.93,4.68h-17c-3.68,0-6.67-2.36-6.67-5.26C8.88,22.47,10.74,20.52,13.34,19.8Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.18,50.1v-.19c0-2.07,2.4-3.75,5.37-3.75A6.12,6.12,0,0,1,26.22,48,4,4,0,0,1,28,47.66c1.78,0,3.22,1,3.22,2.25a1.63,1.63,0,0,1-.21.81c2,.28,3.44,1.49,3.44,2.94,0,1.66-1.93,3-4.3,3H17.79c-2.67,0-4.84-1.51-4.84-3.37C13,51.82,14.3,50.57,16.18,50.1Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.31,51.25h0l1.28,0,.21.65A.25.25,0,0,0,29,52h.07a.23.23,0,0,0,.17-.3h0l-.21-.68,1.43-1.16h0a.23.23,0,0,0,0-.34h0a.29.29,0,0,0-.36,0h0l-1.49,1.21-1.39,0h0a.24.24,0,1,0,0,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,52.15a.36.36,0,0,1-.34-.25l-.18-.58-1.21,0a.36.36,0,0,1-.37-.33.33.33,0,0,1,.1-.25.37.37,0,0,1,.25-.12l1.35,0,1.47-1.18a.36.36,0,0,1,.49,0,.37.37,0,0,1,.1.26.34.34,0,0,1-.13.24l-1.38,1.12.19.61a.33.33,0,0,1,0,.26.43.43,0,0,1-.22.18H29Zm-.37-1,.23.73a.16.16,0,0,0,.14.1h0a.13.13,0,0,0,.09-.07.11.11,0,0,0,0-.1L29,51l1.48-1.2a.18.18,0,0,0,.06-.09.18.18,0,0,0,0-.1.14.14,0,0,0-.2,0h0l-1.52,1.23-1.43,0a.19.19,0,0,0-.1.05.13.13,0,0,0,0,.1.15.15,0,0,0,.16.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M30.7,29.24l.6.49a20.52,20.52,0,0,1,2.55,2.45,21.71,21.71,0,0,0-2.5,1,9.07,9.07,0,0,0-2,1.24c-.86.69-2.37,1.92-2.5,3.8a4.13,4.13,0,0,0,.46,2.18,5.75,5.75,0,0,0,2.82,2.48c4.06,2,9.84.82,10.46.69l.44-.1a20.33,20.33,0,0,0,2.72,4.78,3.27,3.27,0,0,0,1.76,1.12,2.52,2.52,0,0,0,.62.05L61.9,51.3q-1.26,3-2.5,6L58.71,57c-1.2-.51-2.08-.93-2.31-1-3-1.42-5.21-2-7.81-3.35a14.27,14.27,0,0,0-3.3-1.35l-.57-.14c-.8.07-1.9.14-3.22.14a35.11,35.11,0,0,1-8.23-.74,26.94,26.94,0,0,1-5.4-1.85.12.12,0,0,0,0-.14.17.17,0,0,0-.21,0l0,0a24.85,24.85,0,0,1-3.84-2.25,20.92,20.92,0,0,1-5.58-5.65,13.57,13.57,0,0,1-2.4-5.85,9.87,9.87,0,0,1-.06-1.35,8.17,8.17,0,0,1,.73-3.22h0a3.94,3.94,0,0,1,.22-.41,6.47,6.47,0,0,1,2.08-2.26,7.51,7.51,0,0,1,3.53-1.13,10.36,10.36,0,0,1,5,.78A12.6,12.6,0,0,1,30.7,29.24Zm-6.62,3A2.07,2.07,0,1,0,22,34.17,2,2,0,0,0,24.08,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M45.38,29.4l13.71-3.2c-.23.43-.57,1.08-1,1.86-1,1.82-2.11,3.85-3.17,5.43a25.17,25.17,0,0,1-4.25,5,21.88,21.88,0,0,1-9.64,5l-.44.1c-.62.13-6.4,1.3-10.46-.69a5.75,5.75,0,0,1-2.82-2.48,4.13,4.13,0,0,1-.46-2.18c.13-1.88,1.64-3.11,2.5-3.8a9.07,9.07,0,0,1,2-1.24,21.71,21.71,0,0,1,2.5-1,39.59,39.59,0,0,1,6-1.49l5.54-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M48.33,15.22c0,.31,0,.75,0,1.27a40.14,40.14,0,0,1-.71,6.27,30.12,30.12,0,0,1-2.2,6.64h0l-5.54,1.29a39.59,39.59,0,0,0-6,1.49,20.52,20.52,0,0,0-2.55-2.45l-.6-.49c4.69-4.17,9.77-8.3,15.29-12.34Q47.16,16,48.33,15.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.86,48.56a.12.12,0,0,1,0,.14l-.27-.13,0,0A.17.17,0,0,1,27.86,48.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27.87,48.7l0,0-2.1,1.53.32.59a.13.13,0,0,1-.06.18l-.07,0A.16.16,0,0,1,25.8,51l-.35-.63-1.05-.2a.13.13,0,0,1-.11-.16.14.14,0,0,1,.17-.11l1.05.21,2.09-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.07,32.25l6.38-2a8.17,8.17,0,0,0-.73,3.22,9.87,9.87,0,0,0,.06,1.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93,51.28a.36.36,0,0,1-.3-.17h0l-.31-.55-.95-.18a.36.36,0,0,1-.23-.15.37.37,0,0,1-.05-.27.42.42,0,0,1,.15-.22.35.35,0,0,1,.28,0l.95.18,2.07-1.51a.37.37,0,0,1,.49.06l0,0a.33.33,0,0,1,0,.36.34.34,0,0,1-.09.12l-.07-.09.06.09L26,50.34l.24.42a.37.37,0,0,1,0,.27.36.36,0,0,1-.19.21A.34.34,0,0,1,25.93,51.28Zm-.14-.3h0a.14.14,0,0,0,.2.06.2.2,0,0,0,.08-.08.13.13,0,0,0,0-.1l-.32-.59,2.11-1.54,0,0a.11.11,0,0,0,0-.14.17.17,0,0,0-.21,0l0,0L25.51,50.1l-1.05-.21a.2.2,0,0,0-.11,0,.15.15,0,0,0-.06.09.12.12,0,0,0,0,.1.15.15,0,0,0,.09.06l1.05.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.53,29.46l-.29-.13a30.5,30.5,0,0,0,2.19-6.61,39.73,39.73,0,0,0,.7-6.22c0-.38,0-.7,0-1-.7.49-1.39,1-2.09,1.5C40.8,20.89,35.66,25,30.8,29.36l-.21-.24h0c4.86-4.33,10-8.48,15.3-12.35q1.17-.86,2.34-1.68l.26-.19v.32c0,.31,0,.75,0,1.28a41.88,41.88,0,0,1-.71,6.29A30.69,30.69,0,0,1,45.53,29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,44.2A13.84,13.84,0,0,1,30.06,43a6,6,0,0,1-2.89-2.55,4.32,4.32,0,0,1-.48-2.27c.14-2,1.71-3.23,2.55-3.92a10.3,10.3,0,0,1,2-1.26,24.3,24.3,0,0,1,2.51-1,39.68,39.68,0,0,1,6-1.49l5.53-1.3,12.08-2.82,2-.46-.25.47c-.23.43-.54,1-.92,1.71-1,1.8-2.11,3.85-3.17,5.44a25.73,25.73,0,0,1-4.28,5,22,22,0,0,1-9.71,5.06l-.44.1A23.63,23.63,0,0,1,36,44.2Zm9.53-14.68-.12,0-5.54,1.29a39.9,39.9,0,0,0-6,1.48,23.92,23.92,0,0,0-2.49,1,9.31,9.31,0,0,0-2,1.22c-.87.7-2.31,1.88-2.45,3.69a4,4,0,0,0,.46,2.1,5.62,5.62,0,0,0,2.74,2.41c4,1.95,9.72.81,10.36.68l.43-.1h0a21.72,21.72,0,0,0,9.58-5,25.09,25.09,0,0,0,4.22-4.93C55.85,31.83,57,29.78,58,28c.34-.61.62-1.14.84-1.55l-1.29.3C53.51,27.66,49.53,28.6,45.54,29.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.48,57.53l-.83-.35c-1.2-.52-2.08-.93-2.32-1-1.33-.63-2.5-1.08-3.64-1.52a33.3,33.3,0,0,1-4.17-1.83l-.05,0a14.17,14.17,0,0,0-3.22-1.3l-.54-.14c-1.1.09-2.15.14-3.21.14a35.34,35.34,0,0,1-8.26-.74,27.44,27.44,0,0,1-5.43-1.86l.13-.29a27.48,27.48,0,0,0,5.37,1.84,35.8,35.8,0,0,0,8.18.74c1.07,0,2.12-.06,3.22-.14h0l.57.14a14.4,14.4,0,0,1,3.3,1.34l0,0a34.15,34.15,0,0,0,4.13,1.81c1.15.44,2.33.9,3.67,1.53.24.12,1.11.54,2.3,1l.54.22,2.36-5.67L46.11,49.58a2.73,2.73,0,0,1-.63,0,3.43,3.43,0,0,1-1.85-1.17,20.23,20.23,0,0,1-2.75-4.83l.3-.12a20.08,20.08,0,0,0,2.68,4.73,3.13,3.13,0,0,0,1.68,1.08,2.73,2.73,0,0,0,.59,0l16,1.91-.08.19q-1.24,3-2.5,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.53,48.72a26.1,26.1,0,0,1-3.86-2.27,21,21,0,0,1-5.62-5.69,14,14,0,0,1-2.43-5.92,10.54,10.54,0,0,1-.06-1.37,8.33,8.33,0,0,1,.75-3.29l.28.14a8,8,0,0,0-.71,3.16,9.72,9.72,0,0,0,.06,1.32,13.44,13.44,0,0,0,2.38,5.79,20.59,20.59,0,0,0,5.53,5.6,25.53,25.53,0,0,0,3.82,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.73,32.28a21.54,21.54,0,0,0-2.53-2.43l-.6-.48a12.45,12.45,0,0,0-3.33-2,10.43,10.43,0,0,0-5-.76,7.38,7.38,0,0,0-3.45,1.1,6.23,6.23,0,0,0-2,2.21,3,3,0,0,0-.21.39l-.29-.13a3.56,3.56,0,0,1,.22-.42,6.58,6.58,0,0,1,2.14-2.31,7.67,7.67,0,0,1,3.59-1.16,10.72,10.72,0,0,1,5.12.79,12.51,12.51,0,0,1,3.42,2l.6.49A20.57,20.57,0,0,1,34,32.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.78,35l-.07,0L10,32.39a.18.18,0,0,1-.1-.15.17.17,0,0,1,.12-.15l6.37-2a.16.16,0,0,1,.16,0,.16.16,0,0,1,0,.23h0l-.06,0-6,1.87,5.33,2.4a.15.15,0,0,1,.07.21A.15.15,0,0,1,15.78,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.28,26.82q3.82-4,7.66-7.93L30.1,29.15a6.32,6.32,0,0,1-2.66.28,5.61,5.61,0,0,1-3.18-1.37A4.66,4.66,0,0,1,23.28,26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12,29.63a5.48,5.48,0,0,1-.7,0,5.67,5.67,0,0,1-3.27-1.41,5.1,5.1,0,0,1-1-1.28l-.06-.1.09-.09,8-8.25-.89,10.81-.1,0A6.35,6.35,0,0,1,28.12,29.63Zm-4.64-2.78a4.26,4.26,0,0,0,.88,1.09,5.31,5.31,0,0,0,3.09,1.33A5.9,5.9,0,0,0,30,29l.8-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.81,20l-.69.5-.55-.69L31.64,21l-.84-.14.07-1-.84,1L30,20.77l-.63-.48.91-1-.45.14-1,.3-.26-.88,1.4-.21L29,18l.56-.63.94.74V16.77l.93.05L31.29,18l1.09-.89.6.63-1.09.89,1.47,0-.06.78L32,19.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.64,21.11h0L30.78,21a.12.12,0,0,1-.09-.11l0-.73-.63.76a.1.1,0,0,1-.14,0l-.69-.52a.09.09,0,0,1,0-.08.07.07,0,0,1,0-.08l.64-.69-.08,0h0l-1,.3a.08.08,0,0,1-.08,0,.09.09,0,0,1-.06-.06l-.25-.88a.13.13,0,0,1,0-.09.14.14,0,0,1,.08,0l1.12-.16-.79-.53a.22.22,0,0,1-.05-.08.11.11,0,0,1,0-.08l.56-.63a.11.11,0,0,1,.15,0l.76.6v-1.1a.09.09,0,0,1,0-.08s.05,0,.07,0l.94.06a.09.09,0,0,1,.07,0,.11.11,0,0,1,0,.08l-.07.9.91-.74a.11.11,0,0,1,.14,0l.6.63a.13.13,0,0,1,0,.08.12.12,0,0,1,0,.08l-.85.7,1.16,0h0a.09.09,0,0,1,.07,0,.11.11,0,0,1,0,.08l-.05.77a.1.1,0,0,1-.11.1l-1-.06.61.57a.11.11,0,0,1,0,.08.12.12,0,0,1,0,.08l-.7.51a.11.11,0,0,1-.14,0l-.34-.43,0,.82a.08.08,0,0,1,0,.08A.09.09,0,0,1,31.64,21.11Zm-.73-.33.62.1-.07-1a.12.12,0,0,1,.07-.11.11.11,0,0,1,.12,0l.49.62.51-.37-.73-.68a.11.11,0,0,1,0-.12.09.09,0,0,1,.1-.07l1.21.08,0-.56-1.34,0h0a.12.12,0,0,1-.1-.07.11.11,0,0,1,0-.12l1-.82-.46-.48-1,.83a.11.11,0,0,1-.12,0,.1.1,0,0,1,0-.1l.07-1-.72,0v1.21a.1.1,0,0,1-.06.09.11.11,0,0,1-.11,0l-.85-.67-.42.46.91.61a.11.11,0,0,1,.05.12.12.12,0,0,1-.09.08L28.71,19l.19.67,1.32-.41a.11.11,0,0,1,.12.05.09.09,0,0,1,0,.13l-.83.89.51.39.78-.92a.1.1,0,0,1,.18.07ZM29.8,19.45h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 19.32,
    y: 29.47,
    width: 5.69,
    height: 5.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M21.6,33.7a2.12,2.12,0,1,0-2.28-2.11A2.19,2.19,0,0,0,21.6,33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,33.86A2.28,2.28,0,1,1,24,31.59,2.37,2.37,0,0,1,21.6,33.86Zm0-4.23a2,2,0,1,0,2.11,2A2,2,0,0,0,21.6,29.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M21.6,32.86a1.27,1.27,0,1,0-1.37-1.27A1.32,1.32,0,0,0,21.6,32.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,33a1.43,1.43,0,1,1,1.52-1.43A1.48,1.48,0,0,1,21.6,33Zm0-2.54a1.11,1.11,0,1,0,1.2,1.11A1.16,1.16,0,0,0,21.6,30.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M61,19.25a1.28,1.28,0,0,0-.42-.91l-2.82-2.58h0a1.34,1.34,0,0,0-1.88.09l-2.39,2.56a1.1,1.1,0,0,0-.69-.08,1.11,1.11,0,0,0-.61.33l-.63.68a1.14,1.14,0,0,0-.3.8,1.1,1.1,0,0,0,.36.78L54,23.15a1.18,1.18,0,0,0,1.41.11l1.07,1a1,1,0,0,0,.68.26h.05a1,1,0,0,0,.71-.33l.76-.81a1,1,0,0,0,.26-.59,1,1,0,0,0-.13-.63l1.78-1.93A1.35,1.35,0,0,0,61,19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57.74,19.43a.18.18,0,0,1-.05.12l-2.61,2.72-.16.17a.19.19,0,0,1-.12,0,.16.16,0,0,1-.12,0l-2.43-2.22a.13.13,0,0,1,0-.1.15.15,0,0,1,0-.1l.61-.7a.17.17,0,0,1,.12-.05.16.16,0,0,1,.11.05l1.65,1.49,2-2.09a.17.17,0,0,1,.26,0l.66.6a.16.16,0,0,1,.05.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M58.41,20.14a1.14,1.14,0,0,0,.32-.78h0a1.09,1.09,0,0,0-.37-.77L57.69,18h0a1.16,1.16,0,0,0-1.62.06L54.7,19.46,54.21,19l2.33-2.52a.5.5,0,0,1,.26-.11.47.47,0,0,1,.28.09L59.89,19a.47.47,0,0,1,.09.12.32.32,0,0,1,0,.14.34.34,0,0,1,0,.14.32.32,0,0,1-.08.12l-2.4,2.61.5.44s0,0,0,0a.05.05,0,0,1,0,0l-.75.82,0,0-.05,0-1-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M56.83,15.41a1.33,1.33,0,0,1,.89.35h0l2.82,2.58a1.28,1.28,0,0,1,.42.91,1.35,1.35,0,0,1-.34.94l-1.78,1.93a1,1,0,0,1,.13.63,1,1,0,0,1-.26.59l-.76.81a1,1,0,0,1-.71.33h-.05a1,1,0,0,1-.68-.26l-1.07-1A1.19,1.19,0,0,1,54,23.15l-2.45-2.23a1.1,1.1,0,0,1-.36-.78,1.14,1.14,0,0,1,.3-.8l.63-.68a1.14,1.14,0,0,1,.65-.34l.17,0a1.13,1.13,0,0,1,.48.11l2.39-2.56a1.31,1.31,0,0,1,.92-.43h.07m0-.31h-.09a1.67,1.67,0,0,0-1.14.53L53.36,18A1.74,1.74,0,0,0,53,18a1.42,1.42,0,0,0-.57.12,1.45,1.45,0,0,0-.48.34l-.63.68a1.43,1.43,0,0,0,.07,2h0l2.45,2.23h0a1.49,1.49,0,0,0,.75.35,1.44,1.44,0,0,0,.82-.1l.91.82h0a1.32,1.32,0,0,0,.89.34h.07a1.35,1.35,0,0,0,.92-.43l.76-.82a1.39,1.39,0,0,0,.33-.65,1.36,1.36,0,0,0-.05-.72l1.63-1.77a1.68,1.68,0,0,0,.43-1.17,1.66,1.66,0,0,0-.52-1.13h0l-2.82-2.59h0A1.64,1.64,0,0,0,56.83,15.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyBird);
export default __webpack_public_path__ + "static/media/earlyBird.1f6e767a8e2154bdd37af84b1967c974.svg";
export { ForwardRef as ReactComponent };